import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import { addTestAutomationClassName } from 'utils/misc'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import { FORM_ACTION_ERROR_STATUS } from 'constants/form'

export const styles = theme => ({
  root: {
    textAlign: 'center',
    padding: `0 ${theme.spacing(1)}px`,
  },
  errorMessage: {
    padding: `${theme.spacing(2)}px 0`,
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  submitButton: {
    marginTop: 50,
    marginRight: 'auto',
  },
})

const EditDetailsForm = ({
  dirty,
  values,
  status,
  errors,
  classes,
  isSubmitting,
  errorMessage,
  hasFieldError,
  handleFormSubmit,
  handleFieldChange,
  className: classNameProp,
}) => (
  <div className={classNames(classes.root, classNameProp)}>
    {status === FORM_ACTION_ERROR_STATUS && errorMessage ? (
      <Typography className={classes.errorMessage} color="error" align="center">
        {errorMessage}
      </Typography>
    ) : null}
    <form noValidate autoComplete="off" onSubmit={handleFormSubmit}>
      <FormControl
        className={classes.formControl}
        fullWidth
        error={hasFieldError('name')}>
        <TextField
          id="name"
          name="name"
          label="Name"
          value={values.name}
          onChange={handleFieldChange}
          margin="normal"
          error={hasFieldError('name')}
          inputProps={{
            maxLength: 256,
          }}
          className={addTestAutomationClassName('qa-editdetails-field-name')}
        />
        {hasFieldError('name') ? (
          <FormHelperText>{errors.name}</FormHelperText>
        ) : null}
      </FormControl>
      <FormControl className={classes.formControl} fullWidth error={hasFieldError('email')}>
        <TextField
          id="email"
          name="email"
          label="Email Address"
          value={values.email}
          onChange={handleFieldChange}
          margin="normal"
          error={hasFieldError("email")}
          inputProps={{
            maxLength: 256,
          }}
        />
        {
          hasFieldError("email") ?
            <FormHelperText>{errors.email}</FormHelperText> :
            null
        }
      </FormControl>
      <FormControl className={classes.formControl} fullWidth>
        <SubmitButton
          autoFocus
          size="large"
          type="submit"
          color="primary"
          variant="primary"
          showLoader={isSubmitting}
          disabled={isSubmitting || !dirty}
          className={classNames(
            classes.submitButton,
            addTestAutomationClassName('qa-editdetails-button-update')
          )}>
          Update
        </SubmitButton>
      </FormControl>
    </form>
  </div>
)

EditDetailsForm.propTypes = {
  dirty: PropTypes.bool,
  onLogin: PropTypes.func,
  errors: PropTypes.object,
  status: PropTypes.string,
  values: PropTypes.object,
  classes: PropTypes.object,
  rememberMe: PropTypes.bool,
  className: PropTypes.string,
  isSubmitting: PropTypes.bool,
  apiCallError: PropTypes.bool,
  hasFieldError: PropTypes.func,
  errorMessage: PropTypes.string,
  handleFormSubmit: PropTypes.func,
  handleFieldChange: PropTypes.func,
  handleCheckboxChange: PropTypes.func,
}

export default withStyles(styles)(EditDetailsForm)



// WEBPACK FOOTER //
// ./src/components/organisms/EditDetailsForm/EditDetailsForm.js